"use client";
import styles from "./AstroStaticPage.module.scss";
import { useRouter } from "next/navigation";
import FreeKundli from "@/modules/Astro/FreeKundli";
import { AstroUserData } from "@/modules/Astro/Enum";
import { AstroCardData, AstroPageData } from "@/types/common.types";
import AstroCard from "./AstroCard";

const AstroStaticPage = ({ data }: { data: AstroPageData[] }) => {
  const router = useRouter();

  const renderCards = (cardData: AstroCardData[]) => {
    return (
      <div className={styles.cardContainer}>
        {cardData.map((card, index) => (
          <AstroCard {...card} key={index} />
        ))}
      </div>
    );
  };

  const renderCard = (cardData: AstroCardData[]) => {
    return (
      <div className={styles.contentWrapper}>
        <div className={styles.card}>
          {cardData?.map(({ title, description }) => (
            <>
              <h3>{title}</h3>
              <p>{description}</p>
            </>
          ))}
        </div>
      </div>
    );
  };

  const renderTable = (cardData: AstroCardData[]) => {
    return <div></div>;
  };

  const renderNormal = (cardData: AstroCardData[]) => {
    return (
      <div className={styles.contentWrapper}>
        {cardData?.map(({ title, description, aLink }) => (
          <div className={styles.textWrapper}>
            <h3>{title}</h3>
            <p>{description}</p>

            {aLink && (
              <div
                className={styles.aLink}
                dangerouslySetInnerHTML={{ __html: aLink }}
              />
            )}
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      <div className={styles.staticPageWrapper}>
        {data?.map(({ type, data, formDetails }) => {
          if (type === "cards") return renderCards(data);
          if (type === "card") return renderCard(data);
          if (type === "table") return renderTable(data);
          if (type === "kundli-form")
            return (
              <FreeKundli
                title={formDetails?.title}
                submitBtnTxt={formDetails?.submitBtn}
                onFormSubmit={(astroProfile: AstroUserData) => {
                  router.push(
                    `${formDetails?.redirect}?user=${JSON.stringify(
                      astroProfile
                    )}`
                  );
                }}
                formFieldsList={formDetails?.formFields}
              />
            );

          return renderNormal(data);
        })}
      </div>
    </>
  );
};

export default AstroStaticPage;
